
/**
 * ============================================================
 * PersonCard.js — Profile Card for People/Project Pages
 * ============================================================
 *
 * Props:
 *   person: {
 *     id,
 *     firstname,
 *     lastname,
 *     shorttitle,
 *     photo,
 *     institution_name
 *   }
 *
 * Used in:
 *   -> People.js (directory page)
 *   -> Person.js (related people lists)
 *   -> Project.js (project members)
 **/

import React from "react";
import { Link } from "react-router-dom";
import "./css/PersonCard.css";

import { personPhoto } from "../utils/mediaPaths";

// ------------------------------------------------------------
// Component
// ------------------------------------------------------------
function PersonCard({ person }) {

  if (!person) return null;
  
  const {
    id,
    firstname,
    lastname,
    shorttitle,
    photo,
    institution_name
  } = person;

  // Photo path
  const photoSrc = personPhoto(photo);

  // Determine correct institution logo
  let institutionLogo = null;

  if (institution_name === "TMU") {
    institutionLogo = "/logos/tmu-person-logo.svg";
  } else if (institution_name === "GT") {
    institutionLogo = "/logos/gt-person-logo.png";
  }
  // else leave null -> default spacer rendered below


  // ----------------------------------------------------------
  // Render
  // ----------------------------------------------------------
  return (
    <Link to={`/people/${id}`} className="person-card-link">
      <div className="person-card">

        {/* ----- PHOTO ----- */}
        <div className="person-card-image-wrapper">
          <img
            className="person-card-image"
            src={photoSrc}
            alt={`${firstname} ${lastname}`}
          />
        </div>

        {/* ----- NAME + TITLE ----- */}
        <h3 className="person-card-name">
          {firstname} {lastname}
        </h3>

        {shorttitle && shorttitle !== "null" && (
          <h4 className="person-card-title">{shorttitle}</h4>
        )}

        {/* ----- INSTITUTION LOGO ----- */}
        {institutionLogo ? (
          <img
            src={institutionLogo}
            alt={institution_name}
            className="person-card-logo"
          />
        ) : (
          <div className="person-card-logo-space"></div>
        )}

      </div>
    </Link>
  );
}

export default PersonCard;
